module.exports = {
	DATA_HUT: [
		{ name: '祐天寺店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1513'},
		{ name: '下北沢店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1515'},
		{ name: '浦和店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1516'},
		{ name: '自由が丘店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1517'},
		{ name: '行徳店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1518'},
		{ name: '武蔵小山店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1520'},
		{ name: '東長崎店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1522'},
		{ name: '世田谷店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1523'},
		{ name: '奏の杜フォルテ津田沼店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1526'},
		{ name: '新所沢店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1527'},
		{ name: '稲毛店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1541'},
		{ name: '薬円台店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1547'},
		{ name: '船橋店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1550'},
		{ name: '藤沢店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1552'},
		{ name: '相模原大野台店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1559'},
		{ name: '都島店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1567'},
		{ name: '高砂店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2471'},
		{ name: '赤坂店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1578'},
		{ name: '富田 (高槻市)店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2467'},
		{ name: '阿波座店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1587'},
		{ name: '北越谷店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1590'},
		{ name: '横須賀中央店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1904'},
		{ name: '巣鴨店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1908'},
		{ name: '曙橋店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1913'},
		{ name: '小滝橋店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1917'},
		{ name: '中山 (千葉県)店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1920'},
		{ name: '入谷店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1922'},
		{ name: '赤羽店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1927'},
		{ name: '大宮東店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1929'},
		{ name: '新大阪店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2468'},
		{ name: '新百合ヶ丘店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1934'},
		{ name: '鳳店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1954'},
		{ name: '王子店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1962'},
		{ name: '堺大野芝店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1966'},
		{ name: '浦安店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1967'},
		{ name: '秦野落合店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1977'},
		{ name: '梅田店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1978'},
		{ name: '練馬店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1980'},
		{ name: '市川菅野店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1982'},
		{ name: '都賀桜木町店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1988'},
		{ name: '神田店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1994'},
		{ name: '東所沢店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/1996'},
		{ name: '初台店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8510'},
		{ name: '川崎追分町店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8512'},
		{ name: '東銀座店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8513'},
		{ name: '東川口店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8514'},
		{ name: '難波店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8515'},
		{ name: '伊丹店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2469'},
		{ name: '青梅新町店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8522'},
		{ name: '鎌取店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8525'},
		{ name: '豊洲店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8546'},
		{ name: '鴨居店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8558'},
		{ name: '茅ケ崎円蔵店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8559'},
		{ name: '蘇我店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8561'},
		{ name: '下赤塚店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8562'},
		{ name: 'カスミ南越谷店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8564'},
		{ name: '円山店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2004'},
		{ name: '澄川店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2005'},
		{ name: '白石店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2006'},
		{ name: '鶴岡店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2008'},
		{ name: '長久手店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2014'},
		{ name: 'くずは店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2018'},
		{ name: '荒畑店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2020'},
		{ name: '麻生店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2021'},
		{ name: '琴似店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2023'},
		{ name: '新さっぽろ店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2028'},
		{ name: '手稲店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2032'},
		{ name: '苗穂本町店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2033'},
		{ name: '新潟寺尾東店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2036'},
		{ name: '宮崎店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2037'},
		{ name: '三好店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2039'},
		{ name: '糀谷店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2045'},
		{ name: '牡丹山店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2047'},
		{ name: '南郷店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2053'},
		{ name: '北郷店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2054'},
		{ name: '平手店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2056'},
		{ name: '酒田店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2060'},
		{ name: '広島住吉店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2062'},
		{ name: '野幌店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2066'},
		{ name: '広島出汐店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2067'},
		{ name: '南茨木店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2068'},
		{ name: '楠 (愛知県)店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2069'},
		{ name: '戸塚店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2071'},
		{ name: '運河店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2073'},
		{ name: '恵庭店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2079'},
		{ name: '長田 (兵庫県神戸市)店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2083'},
		{ name: '千歳店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2085'},
		{ name: '高松屋島店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2086'},
		{ name: '釧路光陽店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2088'},
		{ name: '甲子園店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2090'},
		{ name: '苫小牧豊川店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2103'},
		{ name: '旭川豊岡店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2105'},
		{ name: '帯広西店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2106'},
		{ name: '恒久店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2112'},
		{ name: '東戸塚店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2114'},
		{ name: '広島府中店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2119'},
		{ name: '武蔵村山店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8566'},
		{ name: '旭川末広店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2125'},
		{ name: '川沿店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2128'},
		{ name: '北札幌店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2131'},
		{ name: '上福岡店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2133'},
		{ name: '西野店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2134'},
		{ name: '帯広店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2135'},
		{ name: '枚方店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2147'},
		{ name: '手稲曙店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2149'},
		{ name: '都城店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2150'},
		{ name: '北見店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2151'},
		{ name: '徳島店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2152'},
		{ name: '伏古店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2161'},
		{ name: '広島五日市コイン通り店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2182'},
		{ name: '東室蘭店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2183'},
		{ name: '姫路京口店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2186'},
		{ name: '姫路広畑店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2187'},
		{ name: '苫小牧明野新町店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2188'},
		{ name: '屯田店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2199'},
		{ name: '東加古川店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2201'},
		{ name: '高砂米田店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2202'},
		{ name: '札幌中央店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2209'},
		{ name: '平岸店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2210'},
		{ name: '芦屋店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2211'},
		{ name: '広島古市店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2218'},
		{ name: '与次郎店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2219'},
		{ name: '湊高台店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2225'},
		{ name: '宇治大久保店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2227'},
		{ name: '八王子店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2228'},
		{ name: '伊敷店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2229'},
		{ name: 'むつ店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2230'},
		{ name: '鎌田リオンドール店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2231'},
		{ name: '富士見店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2232'},
		{ name: '宇治小倉店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2235'},
		{ name: '西宮店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2236'},
		{ name: '垂水店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2237'},
		{ name: '川口新郷店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2239'},
		{ name: '吉祥寺店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2240'},
		{ name: '東林間店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2241'},
		{ name: '池田店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2242'},
		{ name: '岩見沢店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2245'},
		{ name: '上新庄店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2247'},
		{ name: '柏店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2250'},
		{ name: '豊田店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2256'},
		{ name: '高槻春日店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2261'},
		{ name: '東谷山店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2262'},
		{ name: '府中 (東京都)店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2264'},
		{ name: '郡山安積店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2265'},
		{ name: '東八王子店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2269'},
		{ name: '中標津店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2189'},
		{ name: '坂戸店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2271'},
		{ name: '志木店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2281'},
		{ name: '松戸上本郷店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2283'},
		{ name: '小樽店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2284'},
		{ name: '大宮西口店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2289'},
		{ name: '葛西店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2288'},
		{ name: '松江店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2291'},
		{ name: '成田店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8568'},
		{ name: '高井戸店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8570'},
		{ name: '朝霞店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2293'},
		{ name: '春日部店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8571'},
		{ name: '高円寺北店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2473'},
		{ name: '八千代緑が丘店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8574'},
		{ name: '守口店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2297'},
		{ name: '三宮店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2470'},
		{ name: '城東 (大阪府)店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2303'},
		{ name: '北光店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2301'},
		{ name: '東村山店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8579'},
		{ name: '町屋店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2306'},
		{ name: '西新井店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2307'},
		{ name: '海老江店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8581'},
		{ name: '貝塚店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8580'},
		{ name: '西陣 (京都府)店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2318'},
		{ name: 'R1大津店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2321'},
		{ name: '瀬田店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2322'},
		{ name: '草津店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2323'},
		{ name: '烏丸店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2324'},
		{ name: '大島店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2326'},
		{ name: '深川店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2327'},
		{ name: '箕面西宿店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2328'},
		{ name: '生野店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2329'},
		{ name: '石堂店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2331'},
		{ name: '永山店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2332'},
		{ name: '調布店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2333'},
		{ name: '川口店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2334'},
		{ name: '狛江西野川店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2474'},
		{ name: '大泉学園店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2335'},
		{ name: '名谷店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8586'},
		{ name: 'デイリーカナート松原店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8587'},
		{ name: '茨木店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2342'},
		{ name: '向日市上植野店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2343'},
		{ name: '下鴨店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2344'},
		{ name: '美しが丘店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2345'},
		{ name: '熊本中央店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8588'},
		{ name: '一之江店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2346'},
		{ name: '具志川メインシティ店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2347'},
		{ name: '六ッ川店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8593'},
		{ name: '川崎店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2348'},
		{ name: '蒲田店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2349'},
		{ name: '品川店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2351'},
		{ name: '浦和大久保店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2356'},
		{ name: '横浜浅間町店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8597'},
		{ name: '上池台店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2361'},
		{ name: '江戸川 (東京都江戸川区)店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2368'},
		{ name: '福生店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2369'},
		{ name: 'メガステージ白河店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2366'},
		{ name: 'ならやま大通り押熊店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8601'},
		{ name: '業平店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2372'},
		{ name: '宮前平店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8604'},
		{ name: '三鷹店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8605'},
		{ name: '米子米原店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2376'},
		{ name: '松井山手欽明台店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2377'},
		{ name: '文京根津店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8607'},
		{ name: '秋田桜店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2378'},
		{ name: '大蔵谷インター店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8608'},
		{ name: '武蔵浦和店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2386'},
		{ name: '奈良橿原店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2383'},
		{ name: '平塚明石町店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8610'},
		{ name: '大分今津留店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2387'},
		{ name: '日野南店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8611'},
		{ name: '東浦和店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2389'},
		{ name: '五井店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2388'},
		{ name: 'セリオ・コープ西神南店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8614'},
		{ name: 'サンエー西原シティ店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2391'},
		{ name: 'ショッピングプラザ鎌ヶ谷店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8613'},
		{ name: '北綾瀬店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8612'},
		{ name: '青森東店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2394'},
		{ name: '弘前店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2393'},
		{ name: '青森店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2392'},
		{ name: '高島平店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8617'},
		{ name: 'フェニックス通り堺宿院店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8618'},
		{ name: 'ベスタ狭山店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8615'},
		{ name: '環2駒岡店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8619'},
		{ name: '奈良大森西店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2400'},
		{ name: '新潟米山店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2403'},
		{ name: 'イオンタウンユーカリが丘店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8622'},
		{ name: 'MOMOテラス店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2399'},
		{ name: '千歳烏山店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8624'},
		{ name: 'いわき泉店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2404'},
		{ name: '長居店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8625'},
		{ name: '千葉店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2405'},
		{ name: '土浦ピアタウン店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8629'},
		{ name: '入間久保稲荷店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8627'},
		{ name: '山形中央店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2412'},
		{ name: '尼崎店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2409'},
		{ name: '姫島通り姫里店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2411'},
		{ name: '豊中名神口店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2408'},
		{ name: '江坂店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2407'},
		{ name: '大和深見台店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2414'},
		{ name: '高津店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2417'},
		{ name: '鶴見生麦店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8632'},
		{ name: '瀬戸店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2406'},
		{ name: '東住吉店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8633'},
		{ name: 'マックスバリュ昭和橋通店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8636'},
		{ name: '立川店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8640'},
		{ name: '川越店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8645'},
		{ name: '古河店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8642'},
		{ name: '北本二ツ家店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8628'},
		{ name: '函館亀田店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2421'},
		{ name: '十日市場店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8639'},
		{ name: '久里浜店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8635'},
		{ name: '下新城店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8630'},
		{ name: '草加店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8634'},
		{ name: 'ザ・ビッグ平針店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8637'},
		{ name: 'アピタ名古屋北店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8643'},
		{ name: '北青木店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2419'},
		{ name: 'イオンタウン長野三輪店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8646'},
		{ name: '座間キャンプ前店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8647'},
		{ name: 'センター北店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8648'},
		{ name: '本牧店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8650'},
		{ name: '四街道店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8651'},
		{ name: 'イオンタウン木更津請西店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8652'},
		{ name: '甲府店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2423'},
		{ name: 'イオンタウン金沢駅西本町店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8654'},
		{ name: 'マックスバリュ大府店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8653'},
		{ name: '鈴蘭台鳴子店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8649'},
		{ name: '五所川原エルム店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2424'},
		{ name: '三郷店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8655'},
		{ name: '竜美ヶ丘店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8658'},
		{ name: 'イオンタウン熱田千年店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8656'},
		{ name: '町田中町店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8660'},
		{ name: 'マックスバリュ今池店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8662'},
		{ name: '桜美林学園前店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8661'},
		{ name: '竹の塚店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2429'},
		{ name: '川越霞ヶ関店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8663'},
		{ name: '鳴海店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8659'},
		{ name: '南千住店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8668'},
		{ name: '初音町店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8664'},
		{ name: '八潮店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8665'},
		{ name: '東久留米前沢店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8669'},
		{ name: 'エブリイ楠木 (広島県)店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2438'},
		{ name: 'アスティ猪子石店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8671'},
		{ name: '和歌山パームシティ店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2441'},
		{ name: '和歌山店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2439'},
		{ name: '神奈川新町店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8672'},
		{ name: '久喜テラレス店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8673'},
		{ name: '井草店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8675'},
		{ name: '水戸大塚店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8670'},
		{ name: '河内山本駅前店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2442'},
		{ name: '高槻真上店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2443'},
		{ name: '南海千代田駅前店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8674'},
		{ name: '小田原ダイナシティ店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8677'},
		{ name: '戸田店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2444'},
		{ name: 'セブンタウン常盤平店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8679'},
		{ name: '綾瀬寺尾本町店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8676'},
		{ name: '倉敷宮前店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8680'},
		{ name: 'あべの美章園店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8682'},
		{ name: 'R1山科店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2445'},
		{ name: '新松戸店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8684'},
		{ name: '我孫子店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8683'},
		{ name: 'ビバモール名古屋南店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8678'},
		{ name: '俊徳道駅前店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2447'},
		{ name: '岩槻店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8685'},
		{ name: '清瀬店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8686'},
		{ name: '千歳船橋店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8688'},
		{ name: '大森店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2449'},
		{ name: '練馬高野台店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8687'},
		{ name: '堅田店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2446'},
		{ name: '堀切店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2448'},
		{ name: '上池袋店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8689'},
		{ name: '相模原店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2455'},
		{ name: '今店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2457'},
		{ name: '二本松店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2456'},
		{ name: '泉北店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2454'},
		{ name: '岸和田店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2453'},
		{ name: '中野新井店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2458'},
		{ name: '中野南台店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2459'},
		{ name: 'さくらんぼ東根店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2451'},
		{ name: 'ガーラタウン青森西店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2452'},
		{ name: '大宮大和田店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8695'},
		{ name: '金町店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2461'},
		{ name: '東小金井店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2460'},
		{ name: '青葉台店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8693'},
		{ name: 'たまプラーザ店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8694'},
		{ name: '西友二俣川店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8697'},
		{ name: '津島店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2462'},
		{ name: '美浜高洲店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8696'},
		{ name: '狭山亀の甲店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8703'},
		{ name: 'ザ・ビッグ春採店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2463'},
		{ name: 'イオンモール富津店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8702'},
		{ name: '赤堤店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8706'},
		{ name: 'ビッグホップガーデンモール印西店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8700'},
		{ name: '国府多賀城店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2464'},
		{ name: '幕張本郷店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8699'},
		{ name: '高島店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8705'},
		{ name: '流山おおたかの森店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8701'},
		{ name: 'リバーサイド千秋店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2206'},
		{ name: '富山グリーンモール山室店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8707'},
		{ name: '金沢小立野店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8709'},
		{ name: '深谷店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2466'},
		{ name: '常盤台店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8711'},
		{ name: '尾張旭店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8712'},
		{ name: 'ダイエー宝塚中山店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2479'},
		{ name: '神戸御影店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8713'},
		{ name: '宝塚高司店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2478'},
		{ name: '川西能勢口駅前店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2477'},
		{ name: '板橋店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8714'},
		{ name: '武庫之荘店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2476'},
		{ name: '篠路店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2482'},
		{ name: '伊勢原店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2480'},
		{ name: '厚木店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2481'},
		{ name: '石巻店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2475'},
		{ name: '木月店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8715'},
		{ name: '八尾店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2484'},
		{ name: '大東赤井西店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2485'},
		{ name: '門真店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2486'},
		{ name: '福島中央店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2487'},
		{ name: '西明石店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2489'},
		{ name: '魚住店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2490'},
		{ name: 'パビリオンシティ田辺店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2488'},
		{ name: '奈良王寺店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8720'},
		{ name: '住之江加賀屋店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8721'},
		{ name: '半蔵門店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8722'},
		{ name: '富田林店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2491'},
		{ name: '泉大津店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2492'},
		{ name: '和泉中央店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2494'},
		{ name: '太秦店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2495'},
		{ name: 'イオン洛南店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2496'},
		{ name: '湘南台店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2498'},
		{ name: '上尾店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2499'},
		{ name: '向ヶ丘遊園店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2500'},
		{ name: '恵比寿店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2504'},
		{ name: '芝４丁目店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2505'},
		{ name: '若林店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2508'},
		{ name: '長町店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2509'},
		{ name: '岸根店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8726'},
		{ name: '相模原田名店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2511'},
		{ name: '泉市名坂店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2513'},
		{ name: '山鼻店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2514'},
		{ name: '弘前城東 (青森県)店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2515'},
		{ name: 'ロマンシティ御坊店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2516'},
		{ name: '古川北町店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2512'},
		{ name: '大正泉尾店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8728'},
		{ name: '江戸川橋 (東京都文京区)店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8727'},
		{ name: 'みなと通市岡店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8729'},
		{ name: '福岡西新店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2517'},
		{ name: '国分寺店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2518'},
		{ name: 'アクロスプラザ長岡店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2521'},
		{ name: '9号線洛西店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2522'},
		{ name: '旭ヶ丘四条通り店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2519'},
		{ name: '仙台荒井店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2520'},
		{ name: 'ラパーク岸和田春木店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2523'},
		{ name: '米沢春日店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2526'},
		{ name: '月寒店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2527'},
		{ name: '矢野駅前店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2525'},
		{ name: 'イオンモール盛岡インター店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2529'},
		{ name: '西東京富士町店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8731'},
		{ name: '勇舞店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2528'},
		{ name: '金沢文庫店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2530'},
		{ name: 'スーパーアークス桜町店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2524'},
		{ name: 'スーパーセンター海南店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2531'},
		{ name: '東上野店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8730'},
		{ name: '東大阪長田店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2532'},
		{ name: '栄町店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2533'},
		{ name: '橋本店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2534'},
		{ name: '浮之城店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2535'},
		{ name: '玉造店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2536'},
		{ name: '広島庚午店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2537'},
		{ name: '名古屋浅間町駅店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8732'},
		{ name: 'Red Hats店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8666'},
		{ name: '東大阪吉原店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2538'},
		{ name: '網走駒場店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2539'},
		{ name: '仙台長命ヶ丘店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2540'},
		{ name: '仙台西公園通り店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2541'},
		{ name: '新堀川伏見下鳥羽 (京都府)店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2542'},
		{ name: '福山ばら公園前店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2543'},
		{ name: '松山城南店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8733'},
		{ name: '函館美原店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2544'},
		{ name: '函館柏木店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2545'},
		{ name: 'JR松山駅前店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2546'},
		{ name: '水戸元吉田店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8734'},
		{ name: 'トナリエクレオつくば店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8735'},
		{ name: '門真大和田店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2547'},
		{ name: '寝屋川八坂店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2548'},
		{ name: '深沢不動前店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8736'},
		{ name: '豊中西泉丘店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2552'},
		{ name: '杉田店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2549'},
		{ name: '盛岡永井店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2550'},
		{ name: '吹田岸部店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2553'},
		{ name: '上越木田店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2551'},
		{ name: '忍ケ丘駅前店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2554'},
		{ name: '立川若葉町店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2555'},
		{ name: '大阪柏原店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2556'},
		{ name: '郡山新さくら通り店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2557'},
		{ name: 'ひたちなか笹野店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8737'},
		{ name: '香里園店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2559'},
		{ name: '東広島西条店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2558'},
		{ name: '天下茶屋店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8738'},
		{ name: '甚目寺店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2561'},
		{ name: '有田川店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2562'},
		{ name: '六本松店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2565'},
		{ name: 'つくばみらい店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2563'},
		{ name: '須賀川インター店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2564'},
		{ name: '泉南樽井店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2566'},
		{ name: '一宮富士店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8739'},
		{ name: 'リオンドール北三条店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2560'},
		{ name: '荒川沖東店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8740'},
		{ name: 'イオンタウン富雄南店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2567'},
		{ name: '岡山南店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2572'},
		{ name: '羽曳野樫山店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2574'},
		{ name: '下丸子ガス橋通り店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2569'},
		{ name: 'イオン八戸田向店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2568'},
		{ name: '高岡西町店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2573'},
		{ name: '那覇泊店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2570'},
		{ name: 'マックスバリュ垂井店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2571'},
		{ name: '安城横山店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8741'},
		{ name: '川崎渡田店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8742'},
		{ name: '大和高田神楽店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2575'},
		{ name: '新大塚店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8743'},
		{ name: '南草津店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2576'},
		{ name: '出雲斐川店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2577'},
		{ name: '江南店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2578'},
		{ name: 'ギノワンボウル店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2579'},
		{ name: '西立川昭島店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2580'},
		{ name: '七尾ナッピィモール店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2581'},
		{ name: '浅香山店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8744'},
		{ name: '岩出店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2582'},
		{ name: '神栖知手中央店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8746'},
		{ name: '富里七栄店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8747'},
		{ name: '伊勢佐木長者町店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8748'},
		{ name: '大網白里店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8749'},
		{ name: '交野店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2583'},
		{ name: '豊橋往完町店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8751'},
		{ name: '知立店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8752'},
		{ name: '豊橋飯村北店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8753'},
		{ name: '飯塚楽市店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2584'},
		{ name: '山梨昭和店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2585'},
		{ name: '松江乃木店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2586'},
		{ name: '半田青山店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8755'},
		{ name: '豊川千歳通店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8754'},
		{ name: '旭川4条通店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2588'},
		{ name: '栗東店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2590'},
		{ name: '亀戸店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2592'},
		{ name: '9号線亀岡店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2587'},
		{ name: '鳥取駅南店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2589'},
		{ name: '八千代台店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8756'},
		{ name: '手稲前田店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2591'},
		{ name: '鎌倉岩瀬店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8757'},
		{ name: '八王子由木店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8758'},
		{ name: 'MEGAドン・キホーテ蓮田店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8759'},
		{ name: '野々市店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8760'},
		{ name: '谷和原店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/8761'},
		{ name: '桑名店 - ピザハット | ピザハット店舗情報詳細', url: '/huts/2595'}
	]
}



//////////////////
// WEBPACK FOOTER
// ./config/huts.js
// module id = FTsS
// module chunks = 55